var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 45,
    viewBox: "0 0 64 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6236 7.69761C62.2642 6.38425 61.5642 5.1952 60.598 4.25686C59.6044 3.28967 58.3867 2.59782 57.0597 2.2466C52.0935 0.905524 32.1968 0.905525 32.1968 0.905525C23.902 0.808839 15.6094 1.23409 7.36552 2.17887C6.03852 2.55603 4.82306 3.26335 3.82727 4.2379C2.84883 5.20239 2.14012 6.39175 1.7699 7.6949C0.880557 12.6034 0.448454 17.5873 0.479415 22.5795C0.447682 27.5672 0.878725 32.5495 1.7699 37.4641C2.13219 38.7618 2.83825 39.9458 3.81933 40.9022C4.80042 41.8585 6.02215 42.5494 7.36552 42.9151C12.3979 44.2535 32.1968 44.2535 32.1968 44.2535C40.502 44.3503 48.8053 43.9251 57.0597 42.9801C58.3867 42.6289 59.6044 41.9371 60.598 40.9699C61.5639 40.0317 62.2631 38.8425 62.621 37.5291C63.5335 32.6226 63.9772 27.6366 63.9458 22.6418C64.0145 17.6259 63.5713 12.6164 62.6236 7.6949V7.69761Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8713 31.8573V13.3071L42.4255 22.5836L25.8713 31.8573Z",
    fill: "#E1AA43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.ffdb00cb5a2680c4eaa979d8a41c7221.svg";
export { ForwardRef as ReactComponent };